import { Box } from "@mui/material";
import React from "react";

type DKMidDotProps = {
  color: string;
};

const DKMidDot = ({ color }: DKMidDotProps) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      marginX={1}
      sx={{
        fontSize: "0.75rem",
        color: color,
      }}
    >
      &#x2022;
    </Box>
  );
};

export default DKMidDot;
